import { render, staticRenderFns } from "./PaymentBreakdownReport.vue?vue&type=template&id=56ecddcd&"
import script from "./PaymentBreakdownReport.vue?vue&type=script&lang=js&"
export * from "./PaymentBreakdownReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports